import React from "react";

import { Alert as AntAlert } from "antd";

import { trackMixpanel } from "utils";

import { Icon } from "components";

export const Alert = ({
  dataTestId = "",
  className,
  headline = "",
  description,
  textStyle = "",
  type = "warning",
  icon = "",
  closable,
  onClose = () => {},
  onClick = () => {},
  showArrow = false,
  style = {},
  closeIconSize = "",
}) => {
  const getType = () => {
    if (type === "green") {
      return "success";
    }
    if (type === "red") {
      return "error";
    }
    return "warning";
  };

  const getIcon = () => {
    if (icon === "android") {
      return <Icon iconName="tabler/brand-google-play" />;
    }

    if (icon === "ios") {
      return <Icon iconName="tabler/brand-apple" />;
    }

    if (icon === "footprint") {
      return <Icon iconName="tabler/plant" />;
    }
    return <></>;
  };

  return (
    <AntAlert
      data-testid={dataTestId}
      className={className}
      message={headline}
      description={
        typeof description === "string" ? (
          <span className={textStyle} dangerouslySetInnerHTML={{ __html: description }} />
        ) : (
          <span className={textStyle}>{description}</span>
        )
      }
      showIcon={!!icon}
      icon={getIcon()}
      type={getType()}
      closable={closable}
      closeIcon={closable && <Icon iconName="tabler/x" size={closeIconSize} />}
      action={showArrow && <Icon iconName="tabler/arrow-right" onClick={() => {}} />}
      onClose={onClose}
      onClick={(e) => {
        trackMixpanel("ClickBanner", { banner: headline || description });
        onClick?.(e);
      }}
      style={style}
    />
  );
};
